export const enum KEY_ITEMS {
  KILOMETERS = 'kilometres',
  ENGINE_SIZE = 'engineSize',
  SEATS = 'seats',
  COMPLIANCE_YEAR = 'complianceYear',
  FUEL_TYPE = 'fuelType',
  LAST_SERVICE_DATE = 'lastServiceDate',
  BUILD_YEAR = 'buildYear',
  TRANSMISSION = 'transmission',
  VIN_NUMBER = 'vinNumber',
  FUEL_CONSUMPTION = 'fuelConsumption',
  ANCAP_SAFETY_RATING = 'ancapSafetyRating',
  KEYS = 'numberOfKeys',
  DRIVE_TYPE = 'driveType',
  EXTERIOR_COLOR = 'exteriorColor',
  ENGINE_POWER = 'enginePower',
}
